import React from "react";
import excelContactos from "../../assets/Formato de Cargue Contactos Masivo_IDEA.xlsm"

class DownloadLinkContacts extends React.Component {
  constructor(props) {
    super(props);
  }
  render() {
    return (
    <a href={excelContactos} download target="_blank">
       {this.props.children}
     </a>
    );
  }
}

export default DownloadLinkContacts;